import { Color } from '@anov/3d-core'

const CircleShader = {
  uniforms: {
    iTime: { value: 0.0 },
    color: { value: new Color(1.0, 1.0, 1.0) }, // 添加颜色uniform，默认白色
  },
  vertexShader: `
  varying vec2 vUv;
  #include <common>
  #include <logdepthbuf_pars_vertex>
  void main()
  {
  //#include <begin_vertex>
  // #include <project_vertex>
  vUv = uv;
  vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );
  gl_Position = projectionMatrix * mvPosition;
  #include <logdepthbuf_vertex>
  }
  `,
  fragmentShader: `
      varying vec2 vUv;
      uniform float iTime;
      uniform vec3 color;
      #include <logdepthbuf_pars_fragment>
  
      vec4 normalBlend(vec4 base, vec4 blend) {
    // 正常混合模式(非预乘 alpha)
    vec3 resultColor = blend.rgb * blend.a + base.rgb * base.a * (1.0 - blend.a);
    float resultAlpha = blend.a + base.a * (1.0 - blend.a);    
    // 如果结果 alpha 不为零，则除以 alpha 来保持非预乘格式
    if (resultAlpha > 0.0) {
        resultColor /= resultAlpha;
    }   
    return vec4(resultColor, resultAlpha);
}
      void main() {
        #include <logdepthbuf_fragment>
                //*sin(mod(iTime,100.));  //*fract(mod(iTime,100.))
                float progress=fract(mod(iTime,100.))*0.07+0.45;
                         
                     float center1=step(distance(vUv,vec2(0.5,0.5)),0.10);
                     gl_FragColor=vec4(vec3(1.),center1*0.5);

                      float circle2GradientMax=step(distance(vUv,vec2(0.5,0.5)),progress-0.2); 
                      float circle2Gradient=pow(distance(vUv/(progress-0.2),vec2(0.5,0.5)/(progress-0.2)),6.)*0.8; 
                      vec4 circle2GradientC= vec4(vec3(1.),circle2Gradient*circle2GradientMax)*vec4(color*vec3(0.8,0.9,1.4),0.9    *clamp((1.-progress)*40.-19.0,0.,1.));
                      gl_FragColor=normalBlend(gl_FragColor,circle2GradientC); 

              float circleGradientMax=1.-smoothstep(0.24,0.26,distance(vUv,vec2(0.5,0.5))); 
              float circleGradient=pow(distance(vUv/.2/2.,vec2(0.5,0.5)/.2/2.),5.1)*3.; 
              vec4 circleGradien = vec4(vec3(1.),circleGradient*circleGradientMax)*vec4(color,1.9);
             // gl_FragColor=normalBlend(gl_FragColor,circleGradien);
                     
float d = distance(vUv, vec2(0.5, 0.5));
float ring = exp(-120.0 * abs(d - 0.25)); // 指数衰减-10-150 控制光圈大小
vec4 ringColor = vec4(vec3(1.), ring) * vec4(color*1.8, 1.2);
gl_FragColor=normalBlend(gl_FragColor,ringColor);
      }
  `,
}

export default CircleShader